import React, { useEffect } from 'react';
import { Layout, notification } from 'antd';
import AppHeader from './components/Header';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Sidenav } from './components/Sidenav';
import ThemeConfig from './theme';
import Login from './containers/LoginPage';
import { ProtectedLayout } from './components/ProtectedLayout';
import {
  FillIndividualTrader,
  IndividualTraderDetail,
  IndividualTraderList,
  PrepareIndividualTrader,
} from './containers/IndividualSubmissionPage';
import {
  CorporateTraderList,
  PrepareCorporateTrader,
  FillCorporateTrader,
  CorporateTraderDetail,
} from './containers/CorporateSubmissionPage';
import { MarketWatch } from './containers/MarketWatchPage';
import { OrderBook } from './containers/OrderBookPage';
import { TradeBook } from './containers/TradeBookPage';
import { PlaceOrder } from './containers/PlaceOrderPage';
import { Settlement } from './containers/SettlementPage';
import { TradeProcess } from './containers/TradeProcess';
import { OrderQuotationList } from './containers/OrderQuotationPage';
import { ShareHolding } from './containers/ShareHoldingPage';
import { AccountOpening } from './containers/AccountOpeningPage';
import { BlockTrade } from './containers/BlockTradePage';
import { CashIn } from './containers/CashInPage';
import { AddAsset } from './containers/AddAssetPage';
import { Administration } from './containers/BackOfficePage';
import { FillBackOffice } from './containers/FillBackOfficePage';
import { Profile } from './containers/ProfilePage';
import { useAuth } from './hooks/useAuth';
import { FixMessageLog } from './containers/FIXMessageLogPage';
import { FixExecutionOrderLog } from './containers/FIXExecutionOrderLogPage';
import { ChangePassword } from './containers/ChangePasswordPage';
import { DownloadCenter } from './containers/DownloadCenterPage';
import AccountModification from './containers/AccountModificationPage/AccountModification';
import { ShareTransfer } from './containers/ShareTransferPage';
import { CancelBook } from './containers/CancelBookPage';
import TradeProcessHistory from './containers/TradeProcessRecordPage/TradeProcessHistory';
import { OrderBookHistory } from './containers/OrderBookHistoryPage';
import { SecurityCompany } from './containers/SecurityCompanyPage';
import { ShareFreezing } from './containers/ShareFreezingPage';
import { ShareSplitting } from './containers/ShareSplittingPage';
import VerifyAuthentication from './containers/VerifyAuthenticationPage';

export default function App() {
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    notification.destroy();
  }, [location]);
  return (
    <ThemeConfig>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/verify" element={<VerifyAuthentication />} />
        <Route path="/" element={<ProtectedLayout />}>
          <Route index element={<AccountOpening />} />
          <Route element={<IndividualTraderList />} />

          <Route path="individual">
            <Route index element={<IndividualTraderList />} />
            <Route path="prepare" element={<PrepareIndividualTrader />} />
            <Route path="fill/:traderId" element={<FillIndividualTrader type="opening" />} />
            <Route path="detail/:traderId" element={<IndividualTraderDetail />} />
          </Route>

          <Route path="corporate">
            <Route index element={<CorporateTraderList />} />
            <Route path="prepare" element={<PrepareCorporateTrader />} />
            <Route path="fill/:traderId" element={<FillCorporateTrader type="opening" />} />
            <Route path="detail/:traderId" element={<CorporateTraderDetail />} />
          </Route>

          <Route path="modification">
            <Route index element={<AccountModification />} />
            <Route
              path="individual/:traderId"
              element={<FillIndividualTrader type="modification" />}
            />
            <Route
              path="corporate/:traderId"
              element={<FillCorporateTrader type="modification" />}
              type="modification"
            />
            {/* <Route element={<IndividualTraderList />} /> */}
          </Route>
          <Route path="trading">
            <Route index element={<MarketWatch />} />
            <Route path="market-watch" element={<MarketWatch />} />
            <Route path="share-holding" element={<ShareHolding />} />
            <Route path="share-holding/:tradingAccountNo" element={<ShareHolding />} />
            <Route path="cash-in" element={<CashIn />} />
            <Route path="share-freezing" element={<ShareFreezing />} />
            <Route path="share-splitting" element={<ShareSplitting />} />
            <Route path="add-asset" element={<AddAsset />} />
            <Route path="order-book" element={<OrderBook />} />
            <Route path="trade-book" element={<TradeBook />} />
            <Route path="cancel-book" element={<CancelBook />} />
            <Route path="order-book-history" element={<OrderBookHistory />} />
            {/* <Route path="trade-book/:tradeOrderId" element={<OrderExecutionList />} /> */}
            <Route path="order-quotation" element={<OrderQuotationList />} />
            <Route path="place-order" element={<PlaceOrder />} />
            <Route path="settlement" element={<Settlement />} />
            <Route path="trade-process" element={<TradeProcess />} />
            <Route path="trade-process-history" element={<TradeProcessHistory />} />
            <Route path="block-trade" element={<BlockTrade />} />
            <Route path="share-transfer" element={<ShareTransfer />} />
          </Route>
          <Route path="corporate-action">
            <Route path="share-splitting" element={<ShareSplitting />} />
          </Route>
          <Route path="reports">
            <Route index element={<FixMessageLog />} />
            <Route path="fix-message-log" element={<FixMessageLog />} />
            <Route path="fix-execution-order-log" element={<FixExecutionOrderLog />} />
            <Route path="download-center" element={<DownloadCenter />} />
          </Route>

          {user?.role === 'ADMIN' && (
            <Route path="administration">
              <Route index element={<Administration />} />
              <Route path="create" element={<FillBackOffice isUpdate={false} />} />
              <Route path="fill/:backOfficeUserId" element={<FillBackOffice />} />
              <Route path="security-company" element={<SecurityCompany />} />
            </Route>
          )}

          <Route path="profile">
            <Route index element={<Profile />} />
            <Route path="update" element={<FillBackOffice isUpdate={true} />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>

          {/* <Route path="/corporate-submission" element={<CorporateSubmission />} />
          <Route path="/corporate-approval" element={<CorporateApproveRequestt />} />
          <Route path="/preparing-corporate" element={<PreparingCorporate />} />
          <Route path="/filling-corporate" element={<FillingCorporate />} />
          <Route path="/corporate-application" element={<CorporateApplicationInformation />} /> */}
        </Route>
      </Routes>
    </ThemeConfig>
  );
}
